import { useCallback, useEffect, useRef, useState } from "react";
import useApiHttp from "../../hooks/use-http";
import { useParams } from "react-router-dom";
import {
  ActionButton,
  Button,
  Container,
  Image,
  Notifications,
} from "@jds/core";
import JdsModal from "./JdsModal";
import { addParamsURL, downloadFile, getFileNameFromDisposition, makeZipImages } from "../../util/helper";
import { useDispatch } from "react-redux";
import GridContainer from "../Layout/GridContainer";
import Loader from "./Loader/Loader";
import { Box } from "@mui/material";
import decryptUrl from "../../util/img-decryption";
import EmptyState from "../NoData/EmptyState";
import { uploadPhotosActions } from "../../store/state-slices/photosUpload";
import FsLightbox from "fslightbox-react";

const GuestListModal = ({ data }) => {
  const { id: eventId } = useParams();
  const dispatch = useDispatch();
  const { sendRequest: getFaceList, isLoading: isGetFaceListLoading } =
    useApiHttp();

  const { sendRequest: deleteImgReq, isLoading: deleteImgReqing } =
    useApiHttp();
  const { sendRequest: downloadRequest } = useApiHttp();

  const [faceList, setFaceList] = useState([]);
  const [previewImgArr, setPreviewImgArr] = useState([]);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });
  const [photoCount, setPhotoCount] = useState(0);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [deletePhotoId, setDeletePhotoId] = useState(null);
  const [isDeleteModalClose, setDeleteModalClose] = useState(true);
  const guestPhotoObserverRef = useRef(null);
  const openLightboxOnSlide = (number) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number,
    });
  };

  const guestPhotoLastElementRef = useCallback(
    (node) => {
      if (isGetFaceListLoading) return;
      if (guestPhotoObserverRef.current)
        guestPhotoObserverRef.current.disconnect();
      guestPhotoObserverRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) guestPhotoObserverRef.current.observe(node);
    },
    [isGetFaceListLoading, lastPage]
  );

  const getGuestFaceListHandler = () => {
    getFaceList(
      {
        url: `face/organizer-user-photos?eventId=${eventId}&guestId=${data?.id}&page=${page}&size=25`,
        base: "MEDIA",
      },
      null,
      (data) => {
        setPhotoCount(data?.count);
        if (page == 0) {
          setFaceList(data?.data);
          setLastPage(data?.lastPage);
          setPreviewImgArr(
            data?.data?.map((item, i) => (
              <img
                src={addParamsURL(decryptUrl(item?.reducedFileSignedPath), {
                  size: "m",
                })}
                style={{ width: "100%", height: "100%" }}
              />
            ))
          );
        } else {
          setFaceList((prev) => [...prev, ...data?.data]);
          setLastPage(data?.lastPage);
          setPreviewImgArr((pre) => [
            ...pre,
            ...data?.data?.map((item, i) => (
              <img
                src={addParamsURL(decryptUrl(item?.reducedFileSignedPath), {
                  size: "m",
                })}
                style={{ width: "100%", height: "100%" }}
              />
            )),
          ]);
        }
      }
    );
  };
  const downloadMultipleImg = async (files) => {
    dispatch(uploadPhotosActions.setIsStarted(true));
    dispatch(uploadPhotosActions.setIsDownload(true));
    let downloadedImageBlobs = [];
    dispatch(uploadPhotosActions.setTotalCount(files.length));
    for (let i = 0; i < files.length; i++) {
      try {
        const { data: blob, res } = await downloadImg(i, true);
        downloadedImageBlobs.push({ blob, filename: getFileNameFromDisposition(res) });
      } catch (err) {
      } finally {
        if (i + 1 == files.length) {
          makeZipImages(downloadedImageBlobs, "guest-gallery");
          setDownloadLoading(false);
          dispatch(uploadPhotosActions.setTotalCount(0));
          dispatch(uploadPhotosActions.setUploadCount(0));
          dispatch(uploadPhotosActions.setIsDownload(false));
          dispatch(uploadPhotosActions.setIsStarted(false));
        }
      }
    }
  };
  const downloadImg = (index = 0, isMultiple = false) => {
    // const formData = new FormData();
    // formData.append("imageUrl", faceList[index]?.originalFileSignedPath);
    // formData.append("eventId", eventId);
    let mediaId = faceList[index]?.mediaId;
    return new Promise((resolve, reject) => {
      downloadRequest(
        {
          url: `organizer/download`,
          method: "POST",
          base: "MEDIA",
          // formData: true,
          // body: formData,
          body: {
            eventId,
            mediaId,
          },
        },
        null,
        (data, res) => {
          const imageUrl = URL.createObjectURL(data);
          const fileName = getFileNameFromDisposition(res)
          if (!isMultiple) {
            downloadFile(imageUrl, fileName);
            Notifications.toast.success({
              id: "download-photos",
              title: "Image Downloaded",
            });
          } else {
            dispatch(uploadPhotosActions.setUploadCount(index + 1));
            resolve({ data, res }); // Resolve the Promise with the imageUrl
          }
        },
        (err, data) => {
          Notifications.toast.error({
            id: "download-photos-error",
            title: data?.message,
          });
          reject(err);
        }
      );
    });
  };

  const deleteImage = (mediaId) => {
    const deleteIds = mediaId;

    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("mediaIDs", deleteIds);
    deleteImgReq(
      {
        url: `image/delete`,
        method: "DELETE",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "delete-photos",
          tilte: data.message,
        });
        setDeleteModalClose(true);
        setFaceList((pre) => pre.filter((item) => item.id !== mediaId));
      },
      (err, data) =>
        Notifications.toast.error({ id: "delete-photos", tilte: data.message })
    );
  };
  useEffect(() => {
    getGuestFaceListHandler();
  }, [page]);
  return (
    <>
      {isGetFaceListLoading && page == 0 ? (
        <Loader size="small" />
      ) : faceList?.length ? (
        <>
          <div id="face-list-modal">
            <GridContainer
              minWidth="150px"
              maxWidth="159px"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              {faceList.map((item, i) => (
                <div
                  ref={
                    i + 1 == faceList.length ? guestPhotoLastElementRef : null
                  }
                >
                  <Box
                    key={i}
                    sx={{ position: "relative" }}
                    onClick={() => {
                      openLightboxOnSlide(i + 1);
                    }}
                  >
                    <Image
                      // src={item?.thumbnailFileSignedPath}
                      src={addParamsURL(
                        decryptUrl(item?.thumbnailFileSignedPath),
                        { size: "s" }
                      )}
                      aspectRatio="1:1"
                    />
                    <Container
                      style={{
                        position: "absolute",
                        right: "8px",
                        bottom: "8px",
                        gap: "5px",
                      }}
                    >
                      <ActionButton
                        type="secondary"
                        size="small"
                        icon={"IcDownload"}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadImg(i, false);
                        }}
                      />
                      <Button
                        key={item.mediaId}
                        type="secondary"
                        size="small"
                        icon={"IcTrash"}
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeleteModalClose(false);
                          setDeletePhotoId(item.id);
                        }}
                      />
                    </Container>
                  </Box>
                </div>
              ))}
              {isGetFaceListLoading && page !== 0 && (
                <Loader
                  size="small"
                  containerProps={{ style: { height: "100%" } }}
                />
              )}
            </GridContainer>
          </div>

          <Container
            horizontalAlign="center"
            fullWidth
            style={{
              marginTop: "32px",
              gap: "20px",
            }}
            direction="column"
          >
            <Button
              label={downloadLoading ? "Downloading" : "Download"}
              kind="secondary"
              size="medium"
              iconLeft="IcDownload"
              onClick={() => {
                setDownloadLoading(true);
                downloadMultipleImg(faceList);
              }}
              loading={downloadLoading}
              appearance=""
            />
          </Container>
        </>
      ) : (
        <Container fullWidth horizontalAlign="center">
          <EmptyState title="No faces found." action={false} />
        </Container>
      )}
      {previewImgArr.length ? (
        <FsLightbox
          disableLocalStorage={true}
          toggler={lightboxController.toggler}
          sources={previewImgArr}
          slide={lightboxController.slide}
          key={previewImgArr.length}
          onClose={() => { }}
        />
      ) : null}
      <JdsModal
        size="m"
        header="Are you sure you want to delete this photo?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDeleteModalClose}
        onClose={() => {
          setDeleteModalClose(true);
        }}
        onPrimaryClick={() => {
          deleteImage(deletePhotoId);
        }}
        onSecondaryClick={() => setDeleteModalClose(true)}
        primaryCtaDisabled={deleteImgReqing}
      />
    </>
  );
};

export default GuestListModal;
